// Generated by ReScript, PLEASE EDIT WITH CARE

import * as List from "../../../../node_modules/rescript/lib/es6/list.js";
import * as Curry from "../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as AppContext from "../../../context/AppContext.bs.js";
import * as ApiUtils$Catalyst from "../../../../node_modules/@porterin/catalyst/src/utils/ApiUtils.bs.js";
import * as IncentiveCampaignCmp from "./IncentiveCampaignCmp.bs.js";
import * as IncentiveRepoManager from "../repo/IncentiveRepoManager.bs.js";
import * as IncentiveAssetsManager from "../assets/styles/IncentiveAssetsManager.bs.js";
import * as CircularLoader$Catalyst from "../../../../node_modules/@porterin/catalyst/src/components/generic/loaders/CircularLoader.bs.js";
import * as IncentiveContentManager from "../content/IncentiveContentManager.bs.js";
import * as ReasonReactUtils$Catalyst from "../../../../node_modules/@porterin/catalyst/src/utils/ReasonReactUtils.bs.js";
import * as IncentiveCampaignStateMachine from "../state-manager/IncentiveCampaignStateMachine.bs.js";
import * as ErrorDisplayComponent$Catalyst from "../../../../node_modules/@porterin/catalyst/src/components/custom/error/ErrorDisplayComponent.bs.js";

var infoIcon = IncentiveAssetsManager.getImage("info_icon.svg");

function IncentiveDashboardCmp(Props) {
  var msisdn = Props.msisdn;
  var auth_token = Props.auth_token;
  var language = Props.language;
  var match = React.useReducer(IncentiveCampaignStateMachine.reducer, IncentiveCampaignStateMachine.initialState);
  var dispatch = match[1];
  var country = AppContext.useAppContext(undefined).countryConfig;
  React.useEffect((function () {
          Curry._1(dispatch, /* FetchData */{
                _0: {
                  TAG: /* Loading */0,
                  _0: undefined
                }
              });
          var RepoInstance = IncentiveRepoManager.getIncentiveRepo(undefined);
          ApiUtils$Catalyst.handleAPIRequest((function (param) {
                  return Curry._3(RepoInstance.fetchCampaign, msisdn, auth_token, country);
                }), (function (data) {
                  return Curry._1(dispatch, /* FetchData */{
                              _0: {
                                TAG: /* Live */1,
                                _0: data
                              }
                            });
                }), (function (error) {
                  return Curry._1(dispatch, /* FetchData */{
                              _0: {
                                TAG: /* Error */2,
                                _0: error
                              }
                            });
                }));
          
        }), []);
  var data = match[0].campaignsData;
  if (typeof data === "number") {
    return null;
  }
  switch (data.TAG | 0) {
    case /* Loading */0 :
        return React.createElement(CircularLoader$Catalyst.make, {});
    case /* Live */1 :
        var data$1 = data._0;
        var match$1 = List.length(data$1);
        return React.createElement("div", {
                    className: "c-incentive-dashboard"
                  }, React.createElement("div", undefined, match$1 !== 0 ? ReasonReactUtils$Catalyst.listToReactArray(List.map((function (campaign) {
                                    var content = IncentiveContentManager.Content.getIncentiveCampaignContent(language, campaign);
                                    return React.createElement(IncentiveCampaignCmp.make, {
                                                campaign: campaign,
                                                content: content
                                              });
                                  }), data$1)) : React.createElement("div", {
                              className: "no-data"
                            }, React.createElement("div", {
                                  className: "icon"
                                }, React.createElement("img", {
                                      src: infoIcon
                                    })), language >= 7 ? React.createElement("p", undefined, "এখনো আপনার জন্য কোন চলমান ইনসেন্টিভ প্রোগ্রাম চলছে না!") : React.createElement("p", undefined, "There are no active incentive program running for you yet!"))));
    case /* Error */2 :
        return React.createElement(ErrorDisplayComponent$Catalyst.make, {
                    error: data._0
                  });
    
  }
}

var make = IncentiveDashboardCmp;

export {
  infoIcon ,
  make ,
  
}
/* infoIcon Not a pure module */
